<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row gy-3">
    <div class="col-lg-6">
      <generic-dropdown
        [items]="documentTypeOptions"
        [label]="'Document Type'"
        [placeholder]="'Select type'"
        formControlName="documentType"
        [required]="true"
        [errormessage]="'Document type is required'"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6">
      <generic-dropdown
        [items]="projects()"
        [label]="'Project'"
        [placeholder]="'Select project'"
        formControlName="projectId"
        [required]="true"
        [errormessage]="'Project is required'"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-12">
      <input-field
        [label]="'Document Name'"
        [type]="'text'"
        [placeholder]="'Enter document name'"
        formControlName="name"
        [required]="true"
        [requiredLabel]="true"
        [errormessage]="'Document name is required'"
      ></input-field>
    </div>

    <div class="col-12">
      <div class="upload-btn">
        <input
          #fileInput
          type="file"
          (change)="onFileSelected($event)"
          style="display: none"
          accept=".docx,.pdf,.doc"
        />

        @if (selectedFile()) {
          <span
            role="button"
            [ngbTooltip]="'Remove'"
            placement="top"
            class="d-inline-flex mb-3 align-items-center rounded-4 badge border-primary border text-primary fs-14 fw-500 p-2 position-relative"
          >
            <i class="bi bi-filetype-docx me-1"></i>
            <span class="me-2">
              {{ selectedFileName() }}
            </span>
            <i class="bi bi-x-circle text-primary fs-14 stretched-link" (click)="selectedFile.set(null)"></i>
          </span>
        }
        <button class="btn btn-primary btn-h42" type="button" (click)="fileInput.click()">
          <i class="bi bi-upload"></i>
          {{ isReplaceMode() ? 'Select Replacement File' : 'Select File' }}
        </button>
        @if (isUploadFileError()) {
          <span class="text-danger">
            {{ 'A file must be uploaded' }}
          </span>
        }
      </div>
    </div>
  </div>
  <!-- <hr class="my-3 mx-n4 text-muted" /> -->
  <!-- <div class="d-flex justify-content-end gap-2 mb-n2">
    <button type="button" class="btn btn-shadow" (click)="closeModal()" [disabled]="isUploading()">Cancel</button>
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="form.invalid || (!selectedFile()?.name && !template()?.id) || isUploading()"
    >
      @if (isUploading()) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Uploading...
      } @else {
        {{ template()?.id ? 'Replace' : 'Add' }}
      }
    </button>
  </div> -->
</form>
